import { React, useState, useRef } from "react";
import Navbar from "../../Components/Navbar";
import Topbar from "../../Components/Topbar";
import { sendGetRequest, sendPostRequest } from "../../Client";
import ReactLoading from "react-loading";
import { Notyf } from "notyf";
import "notyf/notyf.min.css"; // for React, Vue and Svelte
import Swal from "sweetalert2";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import CustomersBreadcrumb from "../../Components/CustomersBreadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";

function CustomerCarrierServices() {
  const { customerID } = useParams();
  const { carrierID } = useParams();

  const queryClient = useQueryClient();

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const navigate = useNavigate();
  //   const checkbox = useRef();
  //   const [checked, setChecked] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);

  // confirmation notifications
  const notyf = new Notyf({
    position: {
      x: "right",
      y: "top",
    },
  });

  const updatedNotyf = () => {
    notyf.success("Services updated");
  };

  // loading services
  const { data: services, isLoading } = useQuery({
    queryFn: () =>
      sendGetRequest(
        "customers/carriers/services/" + customerID + "/" + carrierID,
        {}
      ),
    queryKey: ["carriers"],
  });

  console.log("services", services);

  const handleSubmit = () => {
    const requestBody = {
      selectedServices: selectedServices,
    };

    const res = sendPostRequest(
      "customers/carriers/services/update/" + customerID + "/" + carrierID,
      requestBody
    );

    updatedNotyf();

    navigate(`/customer/carriers/${customerID}`, {
      replace: true,
      state: { added: 1 },
    });
  };

  if (!isLoading) {
    return (
      <>
        <div className="flex flex-row w-full">
          <Navbar />

          <div className="flex flex-col w-full bg-gray-100 ml-60">
            <Topbar />

            <nav className="flex ml-10 mt-5 h-10" aria-label="Breadcrumb">
              <ol
                role="list"
                className="flex space-x-4 rounded-md bg-white px-6 shadow"
              >
                <li className="flex">
                  <div className="flex items-center">
                    <a
                      href={`/customer/carriers/${customerID}`}
                      className="text-gray-400 hover:text-gray-500"
                    >
                      <span>Back</span>
                    </a>
                  </div>
                </li>
              </ol>
            </nav>

            <div className="bg-white px-4 sm:px-6 lg:px-8 border border-gray-200 ml-10 mr-10 mt-10 mb-40">
              <form>
                <div className="space-y-12">
                  <div className="mt-10">
                    <div className="sm:flex sm:items-center">
                      <div className="sm:flex-auto">
                        <h1 className="text-2xl font-semibold leading-6 text-gray-900 mb-5">
                          Services
                        </h1>
                      </div>
                    </div>

                    <div className="mt-8 flow-root mb-10">
                      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                          <table className="min-w-full divide-y divide-gray-300">
                            <thead>
                              <tr>
                                <th
                                  scope="col"
                                  className="py-3.5 pl-4 pr-3 text-left text-sm font-medium text-gray-900 sm:pl-0"
                                ></th>
                                <th
                                  scope="col"
                                  className="py-3.5 pl-4 pr-3 text-left text-sm font-medium text-gray-900 sm:pl-0"
                                >
                                  Service
                                </th>

                                <th
                                  scope="col"
                                  className="py-3.5 pl-4 pr-3 text-left text-sm font-medium text-gray-900 sm:pl-0"
                                >
                                  Code
                                </th>

                                <th
                                  scope="col"
                                  className="py-3.5 pl-4 pr-3 text-left text-sm font-medium text-gray-900 sm:pl-0"
                                >
                                  Live
                                </th>

                                <th
                                  scope="col"
                                  className="px-3 py-3.5 text-left text-sm font-medium text-gray-900"
                                ></th>
                              </tr>
                            </thead>
                            {!isLoading ? (
                              services?.services?.length > 0 ? (
                                <tbody className="divide-y divide-gray-200">
                                  {services.services?.map((item) => (
                                    <>
                                      <tr key={item.serviceID}>
                                        <td className="relative px-7 sm:w-12 sm:px-6">
                                          <input
                                            type="checkbox"
                                            className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-sky-600 focus:ring-sky-600"
                                            value={item.serviceID}
                                            checked={selectedServices.includes(
                                              item
                                            )}
                                            onChange={(e) =>
                                              setSelectedServices(
                                                e.target.checked
                                                  ? [...selectedServices, item]
                                                  : selectedServices.filter(
                                                      (p) => p !== item
                                                    )
                                              )
                                            }
                                          />
                                        </td>

                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-700 sm:pl-0">
                                          {item.serviceName}
                                        </td>

                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-700 sm:pl-0">
                                          {item.serviceCode}
                                        </td>

                                        <td className="whitespace-nowrap py-4 px-4 text-sm font-medium text-gray-700 sm:pl-0">
                                          {item.freq === 1 ? (
                                            <div className="ml-4 text-center w-12 bg-green-200 ring-green-400 rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset">
                                              LIVE
                                            </div>
                                          ) : (
                                            <div className="text-center w-20 bg-red-200 ring-red-400 rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset">
                                              NOT LIVE
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                                </tbody>
                              ) : (
                                <>
                                  <tbody className="divide-y divide-gray-200">
                                    <tr>
                                      <td
                                        colSpan="4"
                                        className="w-full text-center whitespace-nowrap px-3 py-4 text-sm text-gray-500 col-span-6"
                                      >
                                        -- No Services found --
                                      </td>
                                    </tr>
                                  </tbody>
                                </>
                              )
                            ) : (
                              <>
                                <tbody className="divide-y divide-gray-200">
                                  <tr>
                                    <td
                                      colSpan="5"
                                      className="w-full text-center whitespace-nowrap px-3 py-4 text-sm text-gray-500 col-span-6"
                                    >
                                      <ReactLoading
                                        type={"spin"}
                                        color="#5046e5"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </>
                            )}
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-end gap-x-6 mb-5">
                  <button
                    type="submit"
                    className="flex items-center justify-center rounded-md border border-transparent bg-sky-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-sky-700"
                    onClick={() => handleSubmit()}
                  >
                    Update Services
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CustomerCarrierServices;
